export const Regions = {
    DOURO: { value: 'douro', label: { en: 'Douro', pt: 'Douro' } },
    DAO: { value: 'dao', label: { en: 'Dão', pt: 'Dão' } },
    CHAMPAGNE: { value: 'champagne', label: { en: 'Champagne', pt: 'Champagne' } },
    // ALENTEJO: 'Alentejo'
  };
  
export const WineTypes = {
    RED: { value: 'red', label: { en: 'Red', pt: 'Tinto' } },
    WHITE: { value: 'white', label: { en: 'White', pt: 'Branco' } },
    SPARKLING: { value: 'sparkling', label: { en: 'Sparkling', pt: 'Espumante' } },
    CHAMPAGNE: { value: 'champagne', label: { en: 'Champagne', pt: 'Champagne' } },
    PORTO: { value: 'porto', label: { en: 'Port', pt: 'Porto' } },
    ROSE: { value: 'rose', label: { en: 'Rosé', pt: 'Rosé' } }
  };
  
  export const WineSizes = {
    STANDARD: { value: 'standard', label: { en: 'Standard (0.75L)', pt: 'Padrão (0.75L)' } },
    MAGNUM: { value: 'magnum', label: { en: 'Magnum (1.5L)', pt: 'Magnum (1.5L)' } }
  };
  
  export const WineProducers = {
    MONTEIRINHOS: { value: 'monteirinhos', label: { en: 'Quinta dos Monteirinhos', pt: 'Quinta dos Monteirinhos' } },
    PESSEGUEIRO: { value: 'pessegueiro', label: { en: 'Quinta do Pessegueiro', pt: 'Quinta do Pessegueiro' } },
    COUQUINHO: { value: 'couquinho', label: { en: 'Quinta do Couquinho', pt: 'Quinta do Couquinho' } },
    MUMM: { value: 'mumm', label: { en: 'Mumm', pt: 'Mumm' } }
  };
  
  export const GrapeVarieties = {
    TINTO_CAO: "Tinto Cão",
    TOURIGA_NACIONAL: "Touriga Nacional",
    TOURIGA_FRANCA: "Touriga Franca",
    TINTA_RORIZ: "Tinta Roriz",
    BICAL: "Bical",
    MALVASIA_FINA: "Malvasia Fina",
    CERCEAL: "Cerceal",
    ENCRUZADO: "Encruzado",
    JAEN: "Jaen",
    SOUSAO: "Sousão",
    VINHAS_VELHAS: "Vinhas Velhas",
    RUFETE: "Rufete",
    RABIGATO: "Rabigato",
    VIOSINHO: "Viosinho",
    GOUVEIO: "Gouveio",
    FOLGASAO: "Folgasão",
    TINTA_BARCA: "Tinta da Barca",
    ALICANTE_BOUSCHET: "Alicante Bouschet",
    CODEGA_DO_LARINHO: "Códega do Larinho",
    PINOT_NOIR: "Pinot Noir",
    CHARDONNAY: "Chardonnay",
    PINOT_MEUNIER: "Pinot Meunier"
  }

export const WineMaker = {
    MONTEIRINHOS: { value: 'monteirinhos', label: { en: 'Hugo Chaves de Sousa', pt: 'Hugo Chaves de Sousa' } },
    PESSEGUEIRO: { value: 'pessegueiro', label: { en: 'João Nicolau de Almeida', pt: 'João Nicolau de Almeida' } },
    COUQUINHO: { value: 'couquinho', label: { en: 'Vítor Rabaçal', pt: 'Vítor Rabaçal' } },
  }

export const PriceRanges = {
    RANGE_UNDER_5: { value: 'range_0_5', label: { en: '<5€', pt: '<5€' } },
    RANGE_UNDER_10: { value: 'range_5_10', label: { en: '5-10€', pt: '5-10€' } },
    RANGE_10_20: { value: 'range_10_20', label: { en: '10-20€', pt: '10-20€' } },
    RANGE_20_35: { value: 'range_20_35', label: { en: '20-35€', pt: '20-35€' } },
    RANGE_35_50: { value: 'range_35_50', label: { en: '35-50€', pt: '35-50€' } },
    RANGE_50_100: { value: 'range_50_100', label: { en: '50-100€', pt: '50-100€' } },
    RANGE_OVER_100: { value: 'range_over_100', label: { en: '>100€', pt: '>100€' } }
  }
